import { isEmpty } from 'validation/is-empty.js';
// import Swal from "sweetalert2";
import { dataFromSign } from './authActions';
import { applicationIDAction } from './applicationAction';
import {
  receiveChildrenTable
  // getChildrenArray
} from './children';
import { GET_ERRORS } from './types';
import { getApplicant } from '../../api/api';
import {
  MAIN_USER_ID,
  APPLICANT_NAME,
  APPLICANT_SURNAME,
  APPLICANT_I_SUBMITTER_TYPE,
  APPLICANT_GENDER,
  APPLICANT_ISSUED_BY,
  APPLICANT_DOCUMENT_TYPE,
  APPLICANT_TELEPHONE,
  APPLICANT_RNOKPP,
  APPLICANT_FATHER_NAME,
  APPLICANT_NATIONALITY,
  APPLICANT_SERIES,
  APPLICANT_DATE_OF_ISSUE,
  APPLICANT_D_DOC_STOP,
  APPLICANT_ACT_RECORD_NUMBER,
  APPLICANT_ACT_RECORD_DATE,
  APPLICANT_UNZR_NUMBER,
  APPLICANT_BANK_ID,
  APPLICANT_DOCUMENT_NUMBER,
  APPLICANT_BITHDAY_DATE,
  // APPLICANT_ID,
  APPLICANT_RNOKPP_FEATURE,
  APPLICANT_EMAIL,
  APPLICANT_I_ADDRESSTYPE,
  APPLICANT_L_ADDRESSESMATCH,
  APPLICANT_I_APPLICANT,
  //real address
  APPLICANT_ID_I_APPLICANT,
  // APPLICANT_ADDRESS_ID,
  APPLICANT_C_FLAT,
  APPLICANT_C_BUILDING,
  APPLICANT_I_REGION,
  APPLICANT_C_HOUSING,
  APPLICANT_I_POSTINDEX,
  APPLICANT_I_LOCALITY,
  APPLICANT_I_SUBDIVISION,
  APPLICANT_I_STREET,
  //fact address
  APPLICANT_ID_I_APPLICANT_FACT,
  // APPLICANT_ADDRESS_ID_FACT,
  APPLICANT_C_FLAT_FACT,
  APPLICANT_C_BUILDING_FACT,
  APPLICANT_I_REGION_FACT,
  APPLICANT_C_HOUSING_FACT,
  APPLICANT_I_POSTINDEX_FACT,
  APPLICANT_I_LOCALITY_FACT,
  APPLICANT_I_SUBDIVISION_FACT,
  APPLICANT_I_STREET_FACT,
  //bank
  APPLICANT_P_ACCOUNT,
  APPLICANT_P_MFO,
  APPLICANT_P_EDRPOU,
  APPLICANT_P_NAME,
  APPLICANT_P_ID,
  APPLICANT_ADDRESS_FACT_CLEAR,
  APPLICANT_DOCUMENT_CLEAR,
  SUCCESS_SET_APPLICANT,
  REQUEST_SET_APPLICANT,
  SET_BANKS,
  CLEAR_BANK,
  SUCCESS_DOC_FILES,
  APPLICANT_CLEAR,
  SET_RNOKPP
} from './types';

import * as api from '../../api/api';
import { history } from '../../utils/hist';
import { setDisblement, setRegistrationFop } from './feature.action';
// const Toast = Swal.mixin({
//     toast: true,
//     position: "top-center",
//     showConfirmButton: false,
//     timer: 10000,
//     customClass: {
//       title: "title-class"
//     }
//   });

export const mainActionID = id => {
  return {
    type: MAIN_USER_ID,
    payload: id
  };
};

const setRcnopFeature = value => {
  return {
    type: SET_RNOKPP,
    payload: value
  };
};

// Login - Get User Token okk
export const apllicantData = applData => async dispatch => {
  // console.log(applData);
  // dispatch({ type: REQUEST_SET_APPLICANT });
  dispatch({ type: 'REQUEST_APPLICANT_DATA' });
  try {
    const res = await api.getApplication(applData);
    //console.log("getApplicant",res.data)
    dispatch(applicationIDAction(res.data.id));
    dispatch(setApplicant(res.data));
    const children = res.data.children || [];
    dispatch(receiveChildrenTable(children));
    const docs = res.data.docs || [];
    dispatch(setFiles(docs));
    dispatch(setRcnopFeature(res.data.rnokpp_feature));
    dispatch({ type: 'SUCCESS_APPLICANT_DATA' });
    const notax = res.data.notax; //? true : false;
    const registered = res.data.registered; // ? true : false;
    dispatch(setDisblement(notax));
    dispatch(setRegistrationFop(registered));
    // localStorage.setItem('applicantList', JSON.stringify(res.data));

    // dispatch(getChildrenData(res.data.id));
    //dispatch(getChildrenArray(res.data.id))
    // dispatch(addressIdApplicantFact(res.data.id));
    // dispatch(mainActionID(res.data.id));

    // dispatch(getApplication(res.data.id));
    // localStorage.setItem("ID", JSON.stringify(res.data.id));
    // const applicant = JSON.parse(localStorage.applicant);
    // if (isEmpty(res.data.name)) {
    //   dispatch(dataFromSign(applicant));
    // }

    // history.push('/profile-page/edit');

    return Promise.resolve('OK');
  } catch (error) {
    dispatch({ type: 'FAILURE_APPLICANT_DATA' });
    // history.push('/profile-page');
    return Promise.reject('FAILURE');
  }
  // api.getApplication(applData)
  //   .then(res => {

  //     //console.log("getApplicant",res.data)
  //     dispatch(applicationIDAction(applData));
  //     dispatch(setApplicant(res.data));
  //     dispatch(receiveChildrenTable(res.data.children))
  //     dispatch(setFiles(res.data.docs))
  //     dispatch(setRcnopFeature(res.data.rnokpp_feature))
  //     dispatch({type: 'SUCCESS_APPLICANT_DATA'})
  //     // localStorage.setItem('applicantList', JSON.stringify(res.data));

  //     // dispatch(getChildrenData(res.data.id));
  //     //dispatch(getChildrenArray(res.data.id))
  //     // dispatch(addressIdApplicantFact(res.data.id));
  //     // dispatch(mainActionID(res.data.id));

  //     // dispatch(getApplication(res.data.id));
  //     // localStorage.setItem("ID", JSON.stringify(res.data.id));
  //     // const applicant = JSON.parse(localStorage.applicant);
  //     // if (isEmpty(res.data.name)) {
  //     //   dispatch(dataFromSign(applicant));
  //     // }

  //     // history.push('/profile-page/edit');

  //     return Promise.resolve("OK");
  //   })
  //   .catch(err => {
  //     dispatch({type: 'FAILURE_APPLICANT_DATA'})
  //     history.push('/profile-page');
  //     return Promise.reject("FAILURE");
  //   });
};

export const clearApplicantAddress = () => {
  return { type: APPLICANT_ADDRESS_FACT_CLEAR };
};

export const clearApplicantDocument = () => {
  return { type: APPLICANT_DOCUMENT_CLEAR };
};

export const setApplicant = applicant => {
  return {
    type: SUCCESS_SET_APPLICANT,
    payload: applicant
  };
};

export const edrpouAction = id => {
  return {
    type: APPLICANT_P_EDRPOU,
    payload: id
  };
};
export const bankNameAction = name => {
  return {
    type: APPLICANT_P_NAME,
    payload: name
  };
};

export const mfoAction = mfo => {
  return {
    type: APPLICANT_P_MFO,
    payload: mfo
  };
};

export const saveApplicant = datum => async dispatch => {
  dispatch({ type: 'REQUEST_SAVE_APP' });
  try {
    const { data } = await api.saveApplicant(datum);
    // console.log(data);
    dispatch(applicationIDAction(data.id));

    dispatch({ type: 'SUCCESS_SAVE_APP' });

    return Promise.resolve('OK');
  } catch (error) {
    dispatch({ type: 'FAILURE_SAVE_APP' });
    return Promise.reject('FAILURE');
  }
};

export const savePassport = datum => async dispatch => {
  dispatch({ type: 'REQUEST_SAVE_PASSPORT' });
  try {
    const { data } = await api.savePassport(datum);
    dispatch({ type: 'SUCCESS_SAVE_PASSPORT' });
    return Promise.resolve('OK');
  } catch (error) {
    dispatch({ type: 'FAILURE_SAVE_PASSPORT' });
    return Promise.reject('FAILURE');
  }
};

export const saveAddress = datum => async dispatch => {
  dispatch({ type: 'REQUEST_SAVE_ADDRESS' });
  try {
    const { data } = await api.saveAddress(datum);
    dispatch({ type: 'SUCCESS_SAVE_ADDRESS' });
    return Promise.resolve('OK');
  } catch (error) {
    dispatch({ type: 'FAILURE_SAVE_ADDRESS' });
    return Promise.reject('FAILURE');
  }
};

export const saveBank = datum => async dispatch => {
  function success(params) {
    dispatch({ type: 'SUCCESS_BANK' });
    return params;
  }

  function error(params) {
    dispatch({ type: 'FAILURE_BANK' });
    return params;
  }
  try {
    dispatch({ type: 'REQUEST_BANK' });
    const { data } = await api.saveBank(datum);
    success(data);
    return Promise.resolve('OK');
  } catch (err) {
    error(err);
    return Promise.reject('FAILURE');
  }
};

// get bank by iban

const setBank = data => ({
  type: SET_BANKS,
  payload: data
});

export const clearBankByIBAN = () => ({ type: CLEAR_BANK });
export const applcationClear = () => ({ type: APPLICANT_CLEAR });

export const getBankByIBAN = iban => async dispatch => {
  try {
    const { data } = await api.getBankbyIban(iban);
    if (data.length > 0) {
      dispatch(setBank(data[0]));
      dispatch(mfoAction(data[0].n_mfo));
      dispatch(edrpouAction(data[0].n_edrpou));
      dispatch(bankNameAction(data[0].c_label));
    } else {
      dispatch(clearBankByIBAN());
    }
  } catch (error) {
    dispatch(clearBankByIBAN());
  }
};

export const getApplication = id => async dispatch => {
  try {
    const { data } = await api.getApplication(id);
  } catch (error) {}
};

const setFiles = data => ({
  type: SUCCESS_DOC_FILES,
  payload: data
});

export const setFilesAction = id => async dispatch => {
  try {
    const { data } = await api.getFiles(id);

    dispatch(setFiles(data));
  } catch (error) {}
};

export const typeAction = type => ({ type });

export const applicantAction = (type, value) => {
  switch (type) {
    case 'name':
      return {
        type: APPLICANT_NAME,
        payload: value
      };
    case 'surname':
      return {
        type: APPLICANT_SURNAME,
        payload: value
      };
    case 'fathername':
      return {
        type: APPLICANT_FATHER_NAME,
        payload: value
      };
    case 'i_submittertype':
      return {
        type: APPLICANT_I_SUBMITTER_TYPE,
        payload: value
      };
    case 'gender':
      return {
        type: APPLICANT_GENDER,
        payload: value
      };
    case 'issuedby':
      return {
        type: APPLICANT_ISSUED_BY,
        payload: value
      };
    case 'documenttype':
      return {
        type: APPLICANT_DOCUMENT_TYPE,
        payload: value
      };
    case 'telephone':
      return {
        type: APPLICANT_TELEPHONE,
        payload: value
      };
    case 'rnokpp':
      return {
        type: APPLICANT_RNOKPP,
        payload: value
      };
    case 'nationality':
      return {
        type: APPLICANT_NATIONALITY,
        payload: value
      };
    case 'series':
      return {
        type: APPLICANT_SERIES,
        payload: value.toUpperCase()
      };
    case 'dateofissue':
      return {
        type: APPLICANT_DATE_OF_ISSUE,
        payload: value
      };
    case 'd_doc_stop':
      return {
        type: APPLICANT_D_DOC_STOP,
        payload: value
      };
    case 'unzrNumber':
      return {
        type: APPLICANT_UNZR_NUMBER,
        payload: value
      };
    case 'actRecordNumber':
      return {
        type: APPLICANT_ACT_RECORD_NUMBER,
        payload: value
      };
    case 'actRecordDate':
      return {
        type: APPLICANT_ACT_RECORD_DATE,
        payload: value
      };
    case 'bankid':
      return {
        type: APPLICANT_BANK_ID,
        payload: value
      };
    case 'documentnumber':
      return {
        type: APPLICANT_DOCUMENT_NUMBER,
        payload: value
      };
    case 'bithdaydate':
      return {
        type: APPLICANT_BITHDAY_DATE,
        payload: value
      };
    // case "id":
    //     return {
    //         type: APPLICANT_ID,
    //         payload: value
    //     }
    case 'rnokpp_feature':
      return {
        type: APPLICANT_RNOKPP_FEATURE,
        payload: value
      };
    case 'email':
      return {
        type: APPLICANT_EMAIL,
        payload: value
      };
    case 'c_flat':
      return {
        type: APPLICANT_C_FLAT,
        payload: value
      };
    case 'c_flat_fact':
      return {
        type: APPLICANT_C_FLAT_FACT,
        payload: value
      };
    case 'c_building':
      return {
        type: APPLICANT_C_BUILDING,
        payload: value
      };
    case 'c_building_fact':
      return {
        type: APPLICANT_C_BUILDING_FACT,
        payload: value
      };
    // case "i_applicant":
    // return {
    //     type: APPLICANT_I_APPLICANT,
    //     payload: value
    // }
    case 'i_region':
      return {
        type: APPLICANT_I_REGION,
        payload: value
      };
    case 'i_region_fact':
      return {
        type: APPLICANT_I_REGION_FACT,
        payload: value
      };
    case 'c_housing':
      return {
        type: APPLICANT_C_HOUSING,
        payload: value
      };
    case 'c_housing_fact':
      return {
        type: APPLICANT_C_HOUSING_FACT,
        payload: value
      };
    case 'l_addressesmatch':
      return {
        type: APPLICANT_L_ADDRESSESMATCH,
        payload: value
      };
    case 'i_postindex':
      return {
        type: APPLICANT_I_POSTINDEX,
        payload: value
      };
    case 'i_postindex_fact':
      return {
        type: APPLICANT_I_POSTINDEX_FACT,
        payload: value
      };
    case 'i_locality':
      return {
        type: APPLICANT_I_LOCALITY,
        payload: value
      };
    case 'i_locality_fact':
      return {
        type: APPLICANT_I_LOCALITY_FACT,
        payload: value
      };
    case 'i_subdivision':
      return {
        type: APPLICANT_I_SUBDIVISION,
        payload: value
      };
    case 'i_subdivision_fact':
      return {
        type: APPLICANT_I_SUBDIVISION_FACT,
        payload: value
      };
    case 'i_street':
      return {
        type: APPLICANT_I_STREET,
        payload: value
      };
    case 'i_street_fact':
      return {
        type: APPLICANT_I_STREET_FACT,
        payload: value
      };
    case 'i_addresstype':
      return {
        type: APPLICANT_I_ADDRESSTYPE,
        payload: value
      };
    case 'p_account':
      return {
        type: APPLICANT_P_ACCOUNT,
        payload: value
      };
    // case "p_mfo":
    // return {
    //     type: APPLICANT_P_MFO,
    //     payload: value
    // }
    // case "p_edrpou":
    // return {
    //     type: APPLICANT_P_EDRPOU,
    //     payload: value
    // }
    case 'p_name':
      return {
        type: APPLICANT_P_NAME,
        payload: value
      };
    case 'p_id':
      return {
        type: APPLICANT_P_ID,
        payload: value
      };
    default:
      return value;
  }
};
